import { Trans, useTranslation } from 'next-i18next'
import Drawer from 'modules/drawer/components/drawer/drawer'
import {
  Top,
  Bottom,
  Main,
  Footer,
  FooterButton,
  Outer,
  TopName,
  TopAmount,
} from './one-column-step-layout.styled'
import OrderDetailsDrawerToggle from 'modules/order/components/details-drawer/components/details-drawer-toggle/order-details-drawer-toggle'
import useOrder from 'modules/order/state/order/use-order'
import { getCurrencyDecimalPlaces } from '../../../../utils/currency'

interface FlowOneColumnStepLayoutProps {
  children: React.ReactNode
}

const FlowOneColumnStepLayout = ({ children }: FlowOneColumnStepLayoutProps) => {
  const order = useOrder()
  const { t } = useTranslation()

  const amount = order.dcf.value.isChecked
    ? order.amount.value + order.dcf.value.fee
    : order.amount.value

  return (
    <Outer>
      <Top>
        <TopName>
          <Trans
            i18nKey="oneColumnStepLayout.topName"
            defaults="Thank you {{ firstName }}!"
            values={{ firstName: order.contact.value.firstName }}
          />
        </TopName>
        <TopAmount>
          <Trans
            i18nKey="oneColumnStepLayout.topAmount"
            defaults="Your donation of {{ totalAmount }} {{ currency }} has been processed."
            values={{
              totalAmount: amount.toFixed(getCurrencyDecimalPlaces(order.currency.value)),
              currency: order.currency.value,
            }}
          />
        </TopAmount>
        <OrderDetailsDrawerToggle />
      </Top>
      <Bottom>
        <Drawer position="center" direction="topToBottom" />
        {children}
      </Bottom>
    </Outer>
  )
}

FlowOneColumnStepLayout.Main = Main
FlowOneColumnStepLayout.Footer = Footer
FlowOneColumnStepLayout.FooterButton = FooterButton

export default FlowOneColumnStepLayout
